import { createFileRoute } from '@tanstack/react-router';

import { ReviewConfigPage } from '@/features/reviews/config-page';

export const Route = createFileRoute('/_app/reviews/customize')({
  component: ReviewConfigPage,
});
